import * as React from "react";
import type { SVGProps } from "react";
const SvgHeadset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4c-3.868 0-7 3.132-7 7v.172c.313-.111.65-.172 1-.172 1.652 0 3 1.348 3 3v2c0 1.652-1.348 3-3 3s-3-1.348-3-3v-5c0-4.972 4.028-9 9-9s9 4.028 9 9v5c0 1.358-.91 2.51-2.153 2.878-.346.96-1.23 1.675-2.159 2.14-1.252.625-2.912.982-4.688.982a1 1 0 1 1 0-2c1.534 0 2.874-.313 3.794-.772a3.4 3.4 0 0 0 .836-.56A3.01 3.01 0 0 1 15 16v-2a3.006 3.006 0 0 1 4-2.828V11c0-3.868-3.132-7-7-7m6 13c.548 0 1-.452 1-1v-2c0-.548-.452-1-1-1s-1 .452-1 1v2c0 .548.452 1 1 1M5 16v-2c0-.548.452-1 1-1s1 .452 1 1v2c0 .548-.452 1-1 1s-1-.452-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHeadset;
